<template>
  <div>
    <div class="l-row">
      <form-group label="Tipo de preço" :columns="6" :required="true">
        <select v-model="options.price.type" class="form-select" @change="onChangePriceType">
          <option :value="null">Selecione</option>
          <option v-for="priceType in priceTypeDI" :value="priceType">
            {{ priceType === 'source' ? $t('priceTypeModule.label') + 'Módulo' : $t(priceType).label }}
          </option>
        </select>
      </form-group>

      <form-group label="Percentual" v-if="isTypePercent" :columns="6" :required="true">
        <div class="form-flex">
          <input class="form-input" type="text" v-model="options.price.auxiliary">
          <span class="form-addon">%</span>
        </div>
      </form-group>

      <form-group label="Valor fixo" v-if="isTypeFixedValue" :columns="6" :required="true">
        <money v-model="options.price.auxiliary" v-bind="money" class="form-input"/>
      </form-group>

      <form-group label="Método de customização" :columns="6" v-if="isPriceTypeCustom">
        <select v-model="options.price.custom.method" class="form-select" @change="onChangeCustomMethod">
          <option value="fixed">Fixo</option>
          <option value="percent">Percentual sobre preço da fonte</option>
        </select>
      </form-group>
    </div>

    <div class="l-row" v-if="isPriceTypeCustom">
      <form-group v-if="isPriceCustomMethodPercent" label="Percentual sobre preço da fonte" :columns="6">
        <div class="form-flex">
          <input v-model="options.price.custom.percent" class="form-input"/>
          <span class="form-addon">%</span>
        </div>
      </form-group>

      <form-group v-if="isPriceCustomMethodFixed" :label="$t('price.previous.label')" :columns="6" :required="true">
        <money v-model="options.price.previous" v-bind="money" class="form-input" :disabled="disabled || !options.price.custom.previousUpdate"/>

        <label class="form-checkbox">
          <input type="checkbox" v-model="options.price.custom.previousUpdate">
          <span class="form-checkbox__indicator"></span>
          <span class="form-checkbox__text">Alterar o preço antigo.</span>
        </label>
      </form-group>

      <form-group v-if="isPriceCustomMethodFixed" :label="$t('price.current.label')" :columns="6" :required="true">
        <money v-model="options.price.current" v-bind="money" class="form-input" :disabled="disabled"/>
      </form-group>
    </div>
  </div>
</template>

<script>
  import { Money } from 'v-money'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    inject: ['priceTypeDI'],
    data: () => ({
      options: {
        price: {
          type: 'source',
          previous: 0,
          current: 0,
          custom: {
            method: 'fixed',
            percent: 0,
            previousUpdate: true
          }
        }
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      disabled: true,
      source: {},
      fixedValue: 0,
      isTypeFixedValue: false,
      isTypePercent: false
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    mounted () {
      if (this.options.price.type === '' || this.options.price.type === undefined || this.options.price.type === null) {
        this.options.price.type = 'source'
      }

      if (this.options.price.type === 'source') {
        this.source = {
          previous: this.options.price.previous,
          current: this.options.price.current
        }
      }

      this.onChangePriceType()
    },
    methods: {
      onChangePriceType () {
        if (this.options.price.type === 'source') {
          this.options.price.previous = this.source.previous
          this.options.price.current = this.source.current
        }

        if (
          this.options.price.type === 'source' ||
          this.options.price.type === 'null' ||
          this.options.price.type === null
        ) {
          this.disabled = true
        } else {
          this.disabled = false
        }

        this.isTypePercent = false
        this.isTypeFixedValue = false
        if (this.options.price.type === 'percent') {
          this.isTypePercent = true
        } else if (this.options.price.type === 'fixedValue') {
          this.options.price.auxiliary = 0
          this.isTypeFixedValue = true
        } else {
          this.options.price.auxiliary = null
        }

        this.options.price.custom.percent = 0.0
      },
      onChangeCustomMethod () {
        this.options.price.custom.percent = 0.0
        this.options.price.previous = 0.0
        this.options.price.current = 0.0
      },
      getOptions () {
        switch (this.options.price.type) {
          case 'source':
            return {
              price: {
                type: 'source',
                previous: this.options.price.previous,
                current: this.options.price.current
              }
            }
          case 'custom':
            return {
              price: {
                type: 'custom',
                previous: this.options.price.previous,
                current: this.options.price.current,
                custom: {
                  method: this.options.price.custom.method,
                  percent: this.options.price.custom.percent,
                  previousUpdate: this.options.price.custom.previousUpdate
                }
              }
            }
          case 'percent':
            return {
              price: {
                type: 'percent',
                auxiliary: this.options.price.auxiliary
              }
            }
          case 'fixedValue':
            return {
              price: {
                type: 'fixedValue',
                auxiliary: this.options.price.auxiliary
              }
            }
        }
      }
    },
    computed: {
      isPriceTypeCustom () {
        return this.options.price.type === 'custom'
      },
      isPriceCustomMethodFixed () {
        return this.options.price.custom.method === 'fixed'
      },
      isPriceCustomMethodPercent () {
        return this.options.price.custom.method === 'percent'
      }
    },
    components: {
      FormGroup,
      Money
    }
  }
</script>

<style lang="sass" scoped>
  .form-checkbox
    margin-top: 10px
</style>



// WEBPACK FOOTER //
// Options.vue?a9523432